var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedia = function SvgMedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19.51,
    height: 16.83,
    viewBox: "0 0 19.51 16.83",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", null, React.createElement("path", {
    d: "M19.135,2.385v2.01h-4.78l1.79-2.68.89-1.34h.09a2.01,2.01,0,0,1,2.01,2.01",
    fill: "#d6cece"
  }), React.createElement("path", {
    d: "M15.425.375l-.89,1.34L12.745,4.4H9.665l1.79-2.68.89-1.34Z",
    fill: "#d6cece"
  }), React.createElement("path", {
    d: "M10.735.375l-.89,1.34L8.055,4.4H4.975l1.79-2.68.89-1.34Z",
    fill: "#d6cece"
  }), React.createElement("path", {
    d: "M6.045.375l-.89,1.34-1.79,2.68H.375V2.385A2.017,2.017,0,0,1,2.385.375Z",
    fill: "#d6cece"
  }), React.createElement("path", {
    d: "M12.495,10.125a1.217,1.217,0,0,1,0,2.11l-3.9,2.41a1.567,1.567,0,0,1-.79.22,1.526,1.526,0,0,1-.73-.19,1.242,1.242,0,0,1-.67-1.08V8.765a1.242,1.242,0,0,1,.67-1.08,1.528,1.528,0,0,1,1.52.03Zm-1.01,1.15a.105.105,0,0,0,0-.19l-3.56-2.13a.118.118,0,0,0-.18.1v4.25a.118.118,0,0,0,.18.1Z",
    fill: "#d6cece"
  }), React.createElement("path", {
    d: "M1.715,5.735H.375v8.71a2.017,2.017,0,0,0,2.01,2.01h14.74a2.01,2.01,0,0,0,2.01-2.01V5.735Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M6.405,8.765a1.242,1.242,0,0,1,.67-1.08,1.528,1.528,0,0,1,1.52.03l3.9,2.41a1.217,1.217,0,0,1,0,2.11l-3.9,2.41a1.567,1.567,0,0,1-.79.22,1.526,1.526,0,0,1-.73-.19,1.242,1.242,0,0,1-.67-1.08Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M7.745,13.305V9.055a.118.118,0,0,1,.18-.1l3.56,2.13a.105.105,0,0,1,0,.19L7.925,13.4A.118.118,0,0,1,7.745,13.305Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M4.975,4.4l1.79-2.68.89-1.34h3.08l-.89,1.34L8.055,4.4Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M1.715,4.395H.375V2.385A2.017,2.017,0,0,1,2.385.375h3.66l-.89,1.34-1.79,2.68Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M9.665,4.4l1.79-2.68.89-1.34h3.08l-.89,1.34L12.745,4.4Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M19.135,2.385v2.01h-4.78l1.79-2.68.89-1.34h.09A2.01,2.01,0,0,1,19.135,2.385Z",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/media.1a2aa167.svg";
export { ForwardRef as ReactComponent };